import PermIdentityIcon from "@mui/icons-material/PermIdentity"
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"
import FeedOutlineIcon from "@mui/icons-material/FeedOutlined"

const ClientMenu = {
    id: 'clientRoot',
    title: 'CLIENTS',
    type: 'group',
    icon: PermIdentityIcon,
    children: [
        {
            id: 'clients',
            title: 'Clients',
            type: 'item',
            icon: PersonOutlineIcon,
            url: '/clients'
        },
        {
            id: 'intakeForm',
            title: 'Form Panel',
            type: 'item',
            icon: FeedOutlineIcon,
            url: '/intakeForm'
        },
        // {
        //     id: 'clientMeta',
        //     title: 'Client Machine List',
        //     type: 'item',
        //     icon: PersonOutlineIcon,
        //     url: '/client/meta'
        // },
        {
            id: 'clientHistoryRoot',
            title: 'Client History',
            type: 'collapse',
            icon: PersonOutlineIcon,
           // url: '/clients',
            children: [
                {
                    id: 'treatmentHistory',
                    title: 'Treatment',
                    type: 'item',
                    url: '/treatmentHistory'
                }
                // {
                //     id: 'orderHistory',
                //     title: 'Order Details',
                //     type: 'item',
                //     url: '/orderHistory'
                // },
        //         {
        //             id: 'receiptHistory',
        //             title: 'Receipt History',
        //             type: 'item',
        //             url: '/receiptHistory'
        //         },
        //         {
        //             id: 'billHistory',
        //             title: 'Bills',
        //             type: 'item',
        //             url: '/billHistory'
        //         },
                // {
                //     id: 'paymentHistory',
                //     title: 'Payments',
                //     type: 'item',
                //     url: '/paymentHistory'
                // }
        //         {
        //             id: 'creditHistory',
        //             title: 'Account History',
        //             type: 'item',
        //             url: '/creditHistory'
        //         }
                // {
                //     id: 'familyCreditSessionHistory',
                //     title: 'Credit Session History',
                //     type: 'item',
                //     url: '/familyCreditSessionHistory'
                // }
            ]
        }
    ]
}
export default ClientMenu